import React, { useState } from "react";
import './Account.scss';
import { accountUpdate, uploadAvatar} from "../../Authorization/authSlice";
import { openClearHistoryForm, openDeleteAvatarForm} from "./accountSlice";
import ClearHistoryForm from "./ClearHistoryForm";
import avatar_img from '../../../styles/avatar_default.png';
import '../../Menu/MenuSide/MenuSide.scss';
import DeleteAvatarForm from "./DeleteAvatarForm";
import FinishedQuizes from "./FinishedQuizes/FinishedQuizes";
import { validateFileTypeAvatar, validateFileSizeAvatar } from "../../../helper/validation";
import { validateAvatarImageType, validateAvatarImageSize } from "./accountSlice"; 
//import { Jimp } from "jimp";

const Account = (props) => {
    //FIND USER COUNTRY
    const findValueUserCountry = (usercountry) => {
        const country = [{value: 1,country:"Россия"},
            {value:2,country:"Беларусь"},
            {value:3,country:"Казахстан"},
            {value:4,country:"Армения"},
            {value:5,country:"Таджикистан"},
            {value:6,country:"Узбекистан"}];
        const result = country.find(item => usercountry === item.country);
       // console.log(result);
       return result.value;
    };
    //FIND USER COUNTRY
    const findValueUserOccupation = (occupation) => {
            const country = [{value: 1,occupation:"Инженер"},
                {value:2,occupation:"Архитектор"},
                {value:3,occupation:"Студент"},
                {value:4,occupation:"Пользователь"},
                ];
            const result = country.find(item => occupation === item.occupation);
           // console.log(result);
           return result.value;
        };

    const [username, setUserName] = useState(props.authData.username);
    const [usercountry, setUserCountry] = useState(props.authData.usercountry);
    const [id_occupation, setIdOccupation] = useState(findValueUserOccupation(props.authData.occupation));
    const [selectedFiles, setSelectedFiles] = useState([]);  
    const [valueUserCountry, setValueUserCountry] = useState(findValueUserCountry(props.authData.usercountry));
    const [valueUserOccupation, setValueUserOccupation] = useState(findValueUserOccupation(props.authData.occupation));  
    const [publisherName, setPublisherName] = useState(props.authData.publisherName);  
    const {dispatch} =props;


// PREVIEW AVATAR
const selectFiles = (e) => {
    
    setSelectedFiles(e.target.files);
    //check if file is selected
    if ( e.target.files[0]) {
    //validate type image
    const image = document.getElementById('avatar-image-file');
    const valideTypeMessage = validateFileTypeAvatar(image);
    
    dispatch(validateAvatarImageType(valideTypeMessage));
    //validate size image
    const valideSizeMessage = validateFileSizeAvatar(image);
    console.log(valideTypeMessage);
    console.log(valideSizeMessage);
    console.log(e.target.files[0]);
    console.log(typeof(e.target.files[0]));
    dispatch(validateAvatarImageSize(valideSizeMessage));

    
      const reader = new FileReader();
      //PRE VIEW AVATAR
//reader.readAsArrayBuffer(e.target.files[0]);
      reader.onload = async (e) => {
        const output = document.getElementById('pre-avatar-image');
        output.src = reader.result;
        //output.src = '';
        console.log(e);

//JIMP RESIZE IMG FROM BUFFER

/*
console.log(typeof(output));

        const data = e.target?.result;
        console.log(data);


        if (!data || !(data instanceof ArrayBuffer)) {
            return;
          }
        const image = await Jimp.fromBuffer(data);
        image.resize({ width: 100 });

        console.log(image);
        console.log(URL.createObjectURL(e.target.files[0]));
       // setSelectedFiles(URL.createObjectURL(e.target.files[0]));
       */
      };
      //console.log(reader);


      //JIMP RESIZE IMG FROM BUFFER
      /*
      const data = e.target?.result;
      console.log(data);


      if (!data || !(data instanceof ArrayBuffer)) {
          return;
        }
      const image = await Jimp.fromBuffer(data);
      image.resize({ width: 100 });

*/






        reader.readAsDataURL(e.target.files[0]);
        

      } else return null;

      //JIMP RESIZE IMG FROM BUFFER
 /*     const reader1 = new FileReader();

    reader1.onload = async (e) => {
      const data = e.target?.result;

      if (!data || !(data instanceof ArrayBuffer)) {
        return;
      }

      // Manipulate images uploaded directly from the website.
      const image = await Jimp.fromBuffer(data);
     */ 
      
  }
//HANDLE UPLOAD AVATAR
const handleUpload = e => {
    e.preventDefault();
    const valideTypeMessage = props.accountData.errorAvatarValidateType;
    const valideSizeMessage = props.accountData.errorAvatarValidateSize;
   console.log(valideTypeMessage);
   console.log(valideSizeMessage);
   // const valideType =true;

if (!valideTypeMessage && !valideSizeMessage) {
    let formData = new FormData();
    formData.append("user_id",props.authData.id);
    formData.append("file", selectedFiles[0]);
    
    console.log(formData);
    dispatch(uploadAvatar(formData));
} else return null;

  
  }
//handle load avatar
/*const handlerLoadAvatar = () => {
    const user_id = props.authData.id;
        
    dispatch(getAvatar(user_id));
    var output = document.getElementById('avatar-image');
    output.src = `http://localhost:4001/api/avatar/${user_id}`;
}*/
//<img src={props.accountData.avatarPath} className="avatar"/>

// HANDLE USERNAME
    const handleChangeUsername = (event) => {
        const updateName = event.target.value;
        setUserName(updateName);
    }
// HANDLE PUBLISHER NAME
    const handleChangePublisherName = (event) => {
        const updateName = event.target.value;
        setPublisherName(updateName);
    }

    //HANDLE USERCOUNTRY
    const handleChangeUserCountry= (event) => {
       
        //const updateCountry = event.target.options[event.selectedIndex];
        
        const updateCountry =event.target.options[event.target.selectedIndex].text;
        const updateValueUserCountry =Number(event.target.value);
       // console.log(updateValueUserCountry);
        setUserCountry(updateCountry);
        setValueUserCountry(updateValueUserCountry);
    }
    


    //HANDLE ID OCCUPATION
    const handleIdOccupation= (event) => {
                  
        const updateIdOccupation =event.target.options[event.target.selectedIndex].value;
        //console.log(updateId);
        setIdOccupation(updateIdOccupation);
        const updateValueUserOccupation =Number(event.target.value);
        setValueUserOccupation(updateValueUserOccupation);
    }

// UPDATE ACCOUNT
    
    const onAccountUpdate = () => {
        const item = {
            id: props.authData.id,
            username: username,
            id_occupation: id_occupation,
            usercountry: usercountry,
            publisher: publisherName
        }

        dispatch(accountUpdate(item));
       
    }
/*
   //RENDER TABLE FAVORITES
   const renderFinishedQuizesTable= () => {
    let  data =  props.authData.finishedQuizes;
    //console.log(data);
    return (
        data.map(item => {
            //console.log(item);
            return(
                <tr key={item.quiz_id}>
                    <td className="td-center">{item.quiz_id}</td>
                    <td>{item.quiz_name}</td>
                    <td className="td-center">90/100</td>
                    
                </tr>
                )
            })
        )    
   }
*/
   // RENDER CLEAR HISTORY FORM
   const renderClearHistoryForm = () => {
    //const { dispatch } = this.props;
    //dispatch(openClearHistoryForm);
    if (props.accountData.openClearHistoryForm) {
        return (
            <div>
                <ClearHistoryForm
                dispatch={dispatch}
                user_id={props.authData.id}
                accountData={props.accountData}
                />
            </div>
        )
     } else return null;
   
   }
   
   //RENDER CLEAR HISTORY FORM
   /* if (props.openClearHistoryForm) {
        renderClearHistoryForm();
    };
*/
//HANDLE ON CLEAR HISTORY
const onClearHistory = () => {
    const {dispatch} = props;
    dispatch(openClearHistoryForm());
   
};
   // RENDER DELETE AVATAR FORM
   const renderDeleteAvatarForm = () => {
    //const { dispatch } = this.props;
    //dispatch(openClearHistoryForm);
    if (props.accountData.openDeleteAvatarForm) {
        return (
            <div>
                <DeleteAvatarForm
                dispatch={dispatch}
                user_id={props.authData.id}
                avatar_name = {props.authData.avatarName}
                accountData={props.accountData}
                />
            </div>
        )
     } else return null;
   
   };
//HANDLE ON DELETE AVATAR
const onDeleteAvatar = () => {
    const {dispatch} = props;
    dispatch(openDeleteAvatarForm());
   
};

    //RENDER ALL
    const accountView = props.accountView;
    if (accountView) {
        let style;
           // console.log(props.authData.avatarName);
            if (props.authData.avatarName.user_image_name) {
              
                    style = '';
                } else {
                    style = true;
                }
        return (
            <div className="Account">
                <p className="main-header">Личный кабинет</p>
                <div className="main-container-acc">
                    <p className="header">Личная информация</p>
                    <div className="container">
                        <label htmlFor="nickname-account" >Nickname (используется для поиска)</label>
                        <input id="nickname-account"  placeholder={props.authData.nickName} disabled></input>
                        
                        <label htmlFor="name-account" >Имя (используется для аватара)</label>
                        <input id="name-account"  value={username} onChange={handleChangeUsername}></input> 
                        
                        {(props.authData.modulesName[7].status || (props.authData.userRole[0].role_id === 1)) ? <label htmlFor="name-publisher" >Издатель (используется при создании тестов)</label> : null}
                        {(props.authData.modulesName[7].status || (props.authData.userRole[0].role_id === 1)) ? <input id="name-publisher"  value={publisherName} onChange={handleChangePublisherName}></input>: null} 

                        <label >Профессия</label>
                        <select name="occupation-account"  value={valueUserOccupation} onChange={handleIdOccupation}>
                            <option value="1" >Инженер</option>
                            <option value="2">Архитектор</option>
                            <option value="3">Студент</option>
                            <option value="4">Пользователь</option>
                        </select>
                        
                        <label >Страна</label>
                        <select name="country-account"  value={valueUserCountry} onChange={handleChangeUserCountry}>
                            <option value="1" >Россия</option>
                            <option value="2">Беларусь</option>
                            <option value="3">Казахстан</option>
                            <option value="4">Армения</option>
                            <option value="5">Таджикистан</option>
                            <option value="6">Узбекистан</option>

                        </select>
                        <button onClick={onAccountUpdate}>Cохранить</button> 

                    </div>
                    
                    <div className="container">
                        <p className="header">Аватар</p>
                        <form encType="multipart/form-data" onSubmit={handleUpload} >
                            <img id='pre-avatar-image' src={avatar_img} alt="Avatar" className="avatar"/>
                            <label htmlFor="avatar-image-file" >Изменить аватар</label>
                            <input id='avatar-image-file' type="file" name="avatar-file"  onChange={selectFiles}/>
                            <button className="submit-btn" type='submit'>Обновить</button>
                            <p>Допустимые форматы -jpg, jpeg, png, webp. Допустимый размер файла до 500Кб</p>
                            <p id="error">{props.accountData.errorAvatarValidateSize}</p>
                            <p id="error">{props.accountData.errorAvatarValidateType}</p>
                            
                        </form>
                        <button className="addButton" disabled={style} onClick={onDeleteAvatar}>Удалить</button>
                          {renderDeleteAvatarForm()} 
                            
                    </div>





                    <div className="container">
                      <p className="header">Очистить историю </p>
                      <p >При удалении истории  - результаты, баллы обнуляются.  </p>
                      
                      <button onClick={onClearHistory}>Очистить</button> 
                        { renderClearHistoryForm()}
                    </div> 

                    < FinishedQuizes 
                    finishedQuizes = {props.authData.finishedQuizes}
                    />

{/*
                    <div className="container">
                        <p className="header">Выполненные тесты(баллы) 13/56 </p>
                        <table>
                           
                            <thead>
                                
                                <tr>
                                    <th>№</th>
                                    <th>Название</th>
                                    <th>Баллы</th>
                                </tr>
                            </thead>
                           
                            <tbody>
                            {renderFinishedQuizesTable()} 
                            </tbody>
                        </table>

                    </div>
*/}
                </div>


            </div>
        );   
    } else return null;
    
};
export default Account;